import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PerfectScrollbarConfigInterface, PerfectScrollbarModule, PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { AuthorizationModule } from '../../authorization/authorization.module';
import { SvgIconModule } from '../../shared/svg-icon/svg-icon.module';
import { RouterModule } from '@angular/router';
import { BottomMenuComponent } from './components/bottom-menu/bottom-menu.component';
import { MenuComponent } from './components/menu/menu.component';
import { ClickOutsideModule } from '../../directives/clickOutside';
import { ImageModule } from '../../shared/image/image.module';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};
@NgModule({
  imports: [
    CommonModule,
    PerfectScrollbarModule,
    AuthorizationModule,
    SvgIconModule,
    RouterModule,
    ClickOutsideModule,
    ImageModule
  ],
  declarations: [
    MenuComponent,
    BottomMenuComponent
  ],
  exports: [
    MenuComponent,
    BottomMenuComponent
  ],
  providers: [{
    provide: PERFECT_SCROLLBAR_CONFIG,
    useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
  }]
})
export class MenuModule { }
